/* ==========================================================================
   RasCommerce — scoped Swiper initialiser

   Replaces the template's global carousel.js. Every carousel reads its own
   configuration from data attributes and resolves its pagination / navigation
   elements inside its own wrapper, so any number of carousels can live on one
   page and each section can be re-rendered by the theme editor.
   ========================================================================== */
(function () {
  'use strict';

  var RC = (window.RC = window.RC || {});
  var instances = [];

  function num(value, fallback) {
    var parsed = parseFloat(value);
    return isNaN(parsed) ? fallback : parsed;
  }

  function bool(value, fallback) {
    if (value === undefined || value === '') return fallback;
    return value === true || value === 'true';
  }

  /**
   * Look for a child element inside the carousel's own wrapper. Falls back to
   * the containing section so markup can place arrows outside the .swiper.
   */
  function scopedFind(el, selector) {
    var wrap = el.closest('[data-rc-carousel-wrap]') || el.closest('.shopify-section') || el.parentElement;
    if (!wrap) return null;
    return wrap.querySelector(selector);
  }

  function buildConfig(el) {
    var d = el.dataset;

    var config = {
      slidesPerView: num(d.mobile, 1),
      spaceBetween: num(d.space, 15),
      speed: num(d.speed, 800),
      loop: bool(d.loop, false),
      watchOverflow: true,
      observer: true,
      observeParents: true,
      breakpoints: {
        768: {
          slidesPerView: num(d.tablet, num(d.preview, 3)),
          spaceBetween: num(d.spaceMd, num(d.space, 15))
        },
        1200: {
          slidesPerView: num(d.preview, 4),
          spaceBetween: num(d.spaceLg, num(d.spaceMd, num(d.space, 30)))
        }
      }
    };

    if (bool(d.centered, false)) {
      config.centeredSlides = true;
    }

    if (bool(d.autoPlay, false)) {
      config.autoplay = {
        delay: num(d.delay, 3000),
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      };
    }

    if (d.effect === 'fade') {
      config.effect = 'fade';
      config.fadeEffect = { crossFade: true };
    }

    // Pagination
    var pagination = scopedFind(el, '[data-rc-pagination]');
    if (pagination) {
      config.pagination = {
        el: pagination,
        clickable: true,
        type: d.paginationType === 'fraction' ? 'fraction' : 'bullets'
      };
    }

    // Navigation
    var next = scopedFind(el, '[data-rc-next]');
    var prev = scopedFind(el, '[data-rc-prev]');
    if (next && prev) {
      config.navigation = { nextEl: next, prevEl: prev };
    }

    // Vertical thumbnails (product gallery)
    if (d.direction === 'vertical') {
      config.direction = 'vertical';
    }

    /* Thumbnail linking must be declared at construction time. Assigning
       swiper.thumbs.swiper afterwards leaves the module half-initialised and
       throws inside Swiper on init. The thumbnail carousel appears before the
       main one in the DOM, so its instance already exists here. */
    if (d.rcThumbs) {
      var thumbsEl = document.querySelector(
        '[data-rc-carousel][data-rc-thumbs-id="' + d.rcThumbs + '"]'
      );
      if (thumbsEl && thumbsEl.swiper) {
        config.thumbs = { swiper: thumbsEl.swiper };
      }
    }

    if (bool(d.freeMode, false)) {
      config.freeMode = true;
    }

    if (d.a11yPrev) {
      config.a11y = { prevSlideMessage: d.a11yPrev, nextSlideMessage: d.a11yNext };
    }

    return config;
  }

  function init(scope) {
    if (typeof window.Swiper === 'undefined') return;

    scope.querySelectorAll('[data-rc-carousel]').forEach(function (el) {
      if (el.swiper) return;

      var config = buildConfig(el);
      var swiper = new window.Swiper(el, config);

      instances.push(swiper);
    });
  }

  function destroyWithin(scope) {
    instances = instances.filter(function (swiper) {
      if (!swiper.el || !scope.contains(swiper.el)) return true;
      try {
        swiper.destroy(true, true);
      } catch (e) {
        /* already gone */
      }
      return false;
    });
  }

  RC.initCarousels = init;

  // Thumbnails must exist before the gallery links to them, so run two passes.
  RC.onSectionLoad(function (scope) {
    var root = scope === document ? document : scope;
    init(root);
    init(root);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyWithin(event.target);
  });
})();
